import "@/App.css";
import "lenis/dist/lenis.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Starfield } from "@/components/Starfield";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Anmeldung from "@/pages/Anmeldung";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Kontakt from "@/pages/Kontakt";

let lenisInstance = null;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true, force: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function useLenis() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisInstance = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
}

function App() {
  useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Starfield />
        <div className="grain-overlay" aria-hidden="true" />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/anmeldung" element={<Anmeldung />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/kontakt" element={<Kontakt />} />
        </Routes>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(10,16,38,0.92)",
              border: "1px solid rgba(255,255,255,0.12)",
              color: "#EAF0FF",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
